import { computed, Directive, input } from '@angular/core';
import { FormControl } from '@angular/forms';

/**
 * Base Editor Custom AgGrid for Letter Input.
 * It contains common functionalities used by LetterCellEditorInlineComponent
 * and LetterCellEditorPopupComponent
 */
// This editor acepts only letters no special char
const LETTERS_REGEXP = /^[a-zA-Z ]*$/;
const LETTER_STR = '[a-zA-Z ]';

// Every char other than a-zA-z and blank  chars different
//const NOT_LETTER_REGEXP = /[^A-Za-z ]/g;
@Directive()
export abstract class LetterCellEditorBaseComponent {
    readonly notAdmissibleChars = input.required<string[]>();

    readonly letterFormControl = input.required<FormControl>();

    readonly cellReady = input.required<boolean>();

    readonly notAdmissibleCharsString = computed(() => '[' + this.notAdmissibleChars().join('') + ']' + LETTER_STR);

    readonly notAdmissibleCharsRegexp = computed(() => {
        const notAdmissibleChars = this.notAdmissibleChars();
        if (!notAdmissibleChars.length) return LETTERS_REGEXP;
        return new RegExp(this.notAdmissibleCharsString());
    });
}
